import Img from 'gatsby-image/withIEPolyfill'
import { styled } from 'src/ui/theme'

export const Image = styled(Img)<{ height?: number }>`
  height: ${({ height }) => (height ? height + 'px' : 'auto')};
`
